export default __webpack_public_path__ + "static/media/Image2_Mobile.6769adb2.png";